<app-page-body *ngIf="!isVisibleAuditPage">
  <!-- header -->
  <app-page-header
    *ngIf="showPageHeader"
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form
      [id]="formId"
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      autocomplete="off"
    >
      <section>
        <fieldset>
          <legend>
            {{ pageVocabs + "legend" | translate }}
          </legend>

          <ng-content select="[legend]"> </ng-content>

          <div
            class="tw-flex tw-justify-center flex-column tw-py-[5px] tw-px-[5px]"
          >
            <!-- editable -->
            <div class="editable-table">
              <ng-content select="[BeforeContent]"></ng-content>

              <!-- alert -->
              <div class="tw-mb-5 tw-text-center">
                <span class="text-danger"> * </span>
                <span
                  class="tw-font-medium dark:tw-text-gray-300"
                  translate
                  [translateParams]="{
                    currency: 'common.currency' | translate
                  }"
                >
                  messages.currencyAlert
                </span>
              </div>

              <!-- mciSmartPercent -->
              <div
                class="tw-mb-5 tw-text-center tw-text-primary-700 dark:tw-text-primary-300"
                *ngIf="(groupPrices | json) != ({} | json)"
              >
                {{ "common.mciSmartPercent" | translate }}
                <span class="tw-font-bold">
                  %{{ groupPrices?.mciSmartPercent }}
                </span>
              </div>

              <!-- mtnSmartPercent -->
              <div
                class="tw-mb-5 tw-text-center tw-text-yellow-500"
                *ngIf="(groupPrices | json) != ({} | json)"
              >
                {{ "common.mtnSmartPercent" | translate }}
                <span class="tw-font-bold">
                  %{{ groupPrices?.mtnSmartPercent }}
                </span>
              </div>

              <!-- rightelSmartPercent -->
              <div
                class="tw-mb-5 tw-text-center tw-text-indigo-500"
                *ngIf="(groupPrices | json) != ({} | json)"
              >
                {{ "common.rightelSmartPercent" | translate }}
                <span class="tw-font-bold">
                  %{{ groupPrices?.rightelSmartPercent }}
                </span>
              </div>

              <!-- isPercentageBenefitForInternational -->
              <div
                class="tw-mb-5 tw-text-center tw-text-gray-500 dark:tw-text-gray-300"
                *ngIf="(groupPrices | json) != ({} | json)"
              >
                {{ "common.isPercentageBenefitForInternational" | translate }}
                <span class="tw-font-bold">
                  <i
                    [ngClass]="
                      groupPrices?.isPercentageBenefitForInternational
                        ? 'mdi mdi-check-bold text-success '
                        : ' mdi mdi-close-thick text-danger '
                    "
                  >
                  </i>
                </span>
              </div>

              <!-- internationalBenefitValue -->
              <div
                class="tw-mb-5 tw-text-center tw-text-gray-500 dark:tw-text-gray-300"
                *ngIf="(groupPrices | json) != ({} | json)"
              >
                {{ "common.internationalBenefitValue" | translate }}
                <span
                  class="tw-font-bold"
                  *ngIf="groupPrices?.isPercentageBenefitForInternational"
                >
                  %{{ groupPrices?.internationalBenefitValue }}
                </span>
                <span
                  class="tw-font-bold"
                  *ngIf="!groupPrices?.isPercentageBenefitForInternational"
                >
                  {{ groupPrices?.internationalBenefitValue }}
                  <b>{{ "common.rial" | translate }}</b>
                </span>
              </div>

              <!-- cols -->
              <div class="cols">
                <!-- empty col -->
                <div
                  class="col__item tw-flex-center tw-font-medium tw-text-[13px]"
                >
                  {{ "common.smsCp" | translate }}
                </div>

                <ng-container *ngFor="let item of SmsAggregatorValues">
                  <!-- ignore item 1 and 6 -->
                  <ng-container
                    *ngIf="+item?.value !== 0 && +item?.value !== 6"
                  >
                    <div class="col__item">
                      <!-- title -->
                      <div
                        class="col__title dark:tw-text-gray-200"
                        [class]="item?.key"
                        [smsAggregatorBgColor]="item?.key"
                      >
                        {{ "enums.SmsAggregator." + item?.key | translate }}
                        <img
                          class="tw-mx-3 hide-in-sm"
                          [smsAggregatorImage]="item?.key"
                          [smsAggregatorImageWidth]="item?.key"
                        />
                      </div>

                      <!-- details -->
                      <div class="col__details dark:tw-text-gray-300">
                        <div [smsAggregatorBgColor]="item?.key">
                          {{ "common.farsi" | translate }}
                        </div>

                        <div [smsAggregatorBgColor]="item?.key">
                          {{ "common.latin" | translate }}
                        </div>
                      </div>

                      <!-- inputs -->
                      <div *ngIf="!readOnly" class="col__inputs">
                        <div class="col__input">
                          <input
                            type="number"
                            [id]="'input' + '-' + item.value + '-' + 1"
                            min="0"
                            [onlyNumbers]="true"
                            (keydown)="fillColumn(item.value, 1, $event)"
                            step="50"
                            class="dir-ltr"
                            class="input-group"
                          />
                          <i
                            class="fas fa-arrow-down text-navyBlue"
                            (click)="fillColumn(item.value, 1)"
                          ></i>
                        </div>

                        <div class="col__input">
                          <input
                            type="number"
                            [id]="'input' + '-' + item.value + '-' + 2"
                            min="0"
                            [onlyNumbers]="true"
                            (keydown)="fillColumn(item.value, 2, $event)"
                            step="50"
                            class="dir-ltr input-group"
                          />
                          <i
                            class="fas fa-arrow-down text-navyBlue"
                            (click)="fillColumn(item.value, 2)"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>

              <!-- rows -->
              <div class="rows">
                <ng-container *ngFor="let smsCp of SmsCpValues">
                  <div class="row__flex">
                    <!-- SmsCpValues names -->
                    <div class="row__title">
                      <span> {{ smsCp | enumToText : SmsCpEnumValues }}</span>
                      <!-- <span copyToClipboard> {{item?.smsSenderAgentReference|enumToText:SmsCpEnumValues}}</span> -->
                    </div>

                    <!-- input values -->
                    <ng-container
                      *ngFor="let aggregator of SmsAggregatorValues"
                    >
                      <ng-container
                        *ngIf="
                          +aggregator?.value != 0 && +aggregator?.value != 6
                        "
                      >
                        <div class="row__value">
                          <input
                            type="number"
                            [readOnly]="readOnly"
                            class="input-item dir-ltr"
                            min="0"
                            step="50"
                            (focus)="isEmptyInput($event)"
                            (change)="isEmptyInput($event)"
                            [attr.data-aggregator]="+aggregator?.value"
                            [attr.data-smscp]="smsCp"
                            [attr.data-lang]="1"
                            [id]="
                              'item' + aggregator?.value + '-' + smsCp + '-' + 1
                            "
                            placeholder="-"
                          />

                          <input
                            type="number"
                            [readOnly]="readOnly"
                            class="input-item dir-ltr"
                            min="0"
                            step="50"
                            (focus)="isEmptyInput($event)"
                            (change)="isEmptyInput($event)"
                            [attr.data-aggregator]="+aggregator?.value"
                            [attr.data-smscp]="smsCp"
                            [attr.data-lang]="2"
                            [id]="
                              'item' + aggregator?.value + '-' + smsCp + '-' + 2
                            "
                            placeholder="-"
                          />
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </div>

            <!-- copy paste -->
            <div class="tw-flex-center tw-mt-[20px]">
              <a
                class="btn tw-mx-2"
                [themeColor]="'btn-light-info'"
                copyToClipboard
                (click)="copyTableContent()"
              >
                <span>{{ "common.copyContent" | translate }}</span>
                <i class="mdi mdi-content-copy tw-text-xl"></i>
              </a>

              <a
                *ngIf="!readOnly"
                class="btn tw-mx-2"
                [themeColor]="'btn-light'"
                (click)="pasteTableContent()"
              >
                <i class="mdi mdi-content-paste tw-text-xl"></i>
                <span>{{ "common.pasteContent" | translate }}</span>
              </a>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        *ngIf="!readOnly"
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        buttonType="button"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
